<section class="section-welcome container">
    <div class="left">
        <img src="assets/illustration-security-server.svg" alt="Ilustração - Como protegemos seus dados">
    </div>
    <div class="right">
        <h1>Como protegemos os seus dados</h1>
        <p>A Serasa Experian adota todas as medidas para garantir que suas soluções sejam benéficas para você e para o mercado e, ao mesmo tempo, resguarde a sua privacidade e a segurança dos seus dados pessoais. Adotamos as melhores práticas para a coleta, a utilização, o compartilhamento e o armazenamento dos seus dados.<br>Além disso, observamos rigorosas Políticas Globais de Segurança da Informação que buscam preservar a confidencialidade e a integridade e garantir a disponibilidade dos dados. Tais Políticas se baseiam no framework de Segurança da Informação mais conhecido e usado no mercado: a ISO 27001.</p>
    </div>
</section>
<div class="container">
    <section class="infobox">
        <h2>Como garantimos a proteção dos seus dados</h2>
        <p>Todos os dados são armazenados em ambiente seguro e possuem prazo de retenção e de descarte determinados de acordo com a legislação aplicável, condições contratuais e Políticas Internas do grupo Experian.</p>
        <div class="grid-list">
            <div class="item" *ngFor="let item of infoboxes">
                <div class="icon-area">
                    <img src="{{item.iconUrl}}" alt="{{item.title}}">
                </div>
                <div class="text-area">
                    <h3>{{item.title}}</h3>
                    <p>{{item.description}}</p>
                </div>
            </div>
        </div>
    </section>
</div>
<app-footer-lgpd></app-footer-lgpd>
<app-modal-sidebar></app-modal-sidebar>